define('modules/editor/models/property_groups/geometry',['require','exports','module','backbone','./base','lib/util'],function(require, exports, module) {
  var Backbone = require("backbone"),
      BasePropertyGroup = require("./base"),
      util = require("lib/util");

  module.exports = BasePropertyGroup.extend({
    name: "geometry",
    properties: ["width", "height", "top", "left"],
    generateStyles: function($el, id){
      return [
        {
          selector: "#" + id,
          rules: {
            "width": this.get("width") + "px",
            "height": this.get("height") + (this.get("height") !== 'auto' ? "px" : ''),
            "top": this.get("top") + "px",
            "left": this.get("left") + "px",
          }
        }
      ];
    },
    validators: {
      top: function(attrs){
        var value = parseInt(attrs.top);
        return this.isInteger(attrs.top) && this.isNumber(value) && this.isInRange(value, 0, 2000);
      },
      left: function(attrs){
        var value = parseInt(attrs.left);
        return this.isInteger(attrs.left) && this.isNumber(value) && this.isInRange(value, 0, 2000);
      },
      width: function(attrs){
        var value = parseInt(attrs.width);
        return this.isInteger(attrs.width) && this.isNumber(value) && this.isInRange(value, 1, 2000);
      },
      height: function(attrs){
        var value = parseInt(attrs.height);
        return this.isInteger(attrs.height) && this.isNumber(value) && this.isInRange(value, 1, 2000);
      }
    }
  });

  //util.mixin(module.exports, require("../../behaviours/apply_css_properties"));

});

